import { useState } from "react";
import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { updateSetting } from "../../stores/actions/settings.actions.types";
import { Modal, Button } from "@mantine/core";
import { TextInput } from "../UI/FormField";
import { FaPlus } from "react-icons/fa";
import { BiLoaderAlt } from "react-icons/bi";
import { RxCross2 } from "react-icons/rx";

const SmsVariablesModal = ({ setting, updateSetting, setReload, reload }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    smsVariables: [""],
  };

  const validationSchema = Yup.object().shape({
    smsVariables: Yup.array().of(Yup.string().required("Value required")),
  });

  const handleSubmit = (values, { resetForm }) => {
    setLoading(true);
    const callback = (data) => {
      setLoading(false);
      if (data?.success) {
        setReload(!reload);
        resetForm();
        setModalOpen(false);
      }
    };

    updateSetting({
      data: {
        ...setting,
        smsVariables: [
          ...setting.smsVariables,
          ...values.smsVariables.filter(Boolean),
        ],
      },
      callback,
    });
  };

  return (
    <div className='my-4'>
      <button
        className='bg-red-600 block ml-auto px-5 py-1 text-white rounded text-center'
        onClick={() => setModalOpen(true)}
      >
        SMS Variables
      </button>

      <Modal
        opened={modalOpen}
        onClose={() => setModalOpen(false)}
        title='SMS Variables'
        centered
      >
        {/* List existing variables */}
        <div className='grid grid-cols-2 gap-5  max-h-96 p-3  mb-5'>
          {setting?.smsVariables?.map((v, i) => (
            <div key={i} className='border rounded-xl p-3 bg-gray-50'>
              <p className='font-mono text-sm'>{`{{${v}}}`}</p>
            </div>
          ))}
        </div>

        {/* 
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values }) => (
            <Form>
              <FieldArray name='smsVariables'>
                {({ push, remove }) => (
                  <>
                    {values.smsVariables.map((value, index) => (
                      <div
                        key={index}
                        className='flex items-center gap-4 mb-3 relative'
                      >
                        <div className='w-full'>
                          <TextInput
                            name={`smsVariables.${index}`}
                            placeholder='ex: customer-signup'
                          />
                        </div>
                        {index > 0 && (
                          <RxCross2
                            onClick={() => remove(index)}
                            className='cursor-pointer text-red-600 text-xl'
                            title='Remove'
                          />
                        )}
                      </div>
                    ))}
                    <button
                      type='button'
                      onClick={() => push("")}
                      className='my-2 text-sm bg-red-600 text-white px-4 py-2 rounded hover:opacity-90'
                    >
                      <FaPlus className='inline mr-2' /> Add More
                    </button>
                  </>
                )}
              </FieldArray>

              <button
                type='submit'
                disabled={loading}
                className='w-full bg-red-600 text-white py-2 rounded-md mt-6'
              >
                {loading ? (
                  <BiLoaderAlt className='animate-spin text-2xl m-auto text-white' />
                ) : (
                  "Save Changes"
                )}
              </button>
            </Form>
          )}
        </Formik> */}
      </Modal>
    </div>
  );
};

export default connect(null, { updateSetting })(SmsVariablesModal);
